import { render, staticRenderFns } from "./indexApp.vue?vue&type=template&id=022481a5"
import script from "./indexApp.vue?vue&type=script&lang=ts"
export * from "./indexApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports